import { CommentModel } from "./Comment.model";

export class Comment extends CommentModel {
    // Add custom methods here
}
